import { createBrowserRouter } from "react-router-dom";

import Sentry from "../sentry";

const createSentryBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

export default createSentryBrowserRouter;
